/** Registrations per day (bars) and running total (line) */

import { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import type { DayPoint } from '../utils/reportCharts';

export function RegistrationsTimelineChart({ points, height = 300 }: { points: DayPoint[]; height?: number }) {
  const [isDark, setIsDark] = useState(() => document.documentElement.classList.contains('dark'));
  useEffect(() => {
    const observer = new MutationObserver(() => setIsDark(document.documentElement.classList.contains('dark')));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  if (points.length === 0) {
    return <div className="flex h-40 items-center justify-center text-muted-foreground">No hay datos disponibles</div>;
  }

  const text = isDark ? '#cbd5e1' : '#64748b';
  const grid = isDark ? '#475569' : '#e2e8f0';
  const label = (day: string) => {
    const [, m, d] = day.split('-');
    return `${d}/${m}`;
  };

  const option = {
    tooltip: {
      trigger: 'axis',
      backgroundColor: isDark ? '#1e293b' : '#ffffff',
      borderColor: grid,
      textStyle: { color: isDark ? '#f1f5f9' : '#0f172a' },
    },
    legend: { data: ['Por día', 'Acumulado'], textStyle: { color: text }, top: 0 },
    grid: { left: '3%', right: '4%', bottom: '3%', top: 36, containLabel: true },
    xAxis: {
      type: 'category',
      data: points.map((p) => label(p.day)),
      axisLabel: { color: text },
      axisLine: { lineStyle: { color: grid } },
    },
    yAxis: [
      { type: 'value', minInterval: 1, axisLabel: { color: text }, splitLine: { lineStyle: { color: grid } } },
      { type: 'value', minInterval: 1, axisLabel: { color: text }, splitLine: { show: false } },
    ],
    series: [
      { name: 'Por día', type: 'bar', data: points.map((p) => p.count), itemStyle: { color: '#3b82f6' } },
      {
        name: 'Acumulado',
        type: 'line',
        yAxisIndex: 1,
        smooth: true,
        symbol: 'circle',
        data: points.map((p) => p.cumulative),
        itemStyle: { color: '#16a34a' },
      },
    ],
  };

  return <ReactECharts option={option} style={{ height }} notMerge />;
}
